export interface ComposerKeyEvent {
  key: string;
  shiftKey: boolean;
  /** True while an IME (Japanese, Chinese…) is composing; Enter then confirms the word. */
  isComposing: boolean;
}

/**
 * The composer's Enter rule: on a keyboard Enter sends and Shift+Enter adds a line; on a
 * touch device Enter always adds a line and only the Send button sends.
 */
export const shouldSendOnEnter = (event: ComposerKeyEvent, isTouchDevice: boolean): boolean =>
  event.key === "Enter" && !event.shiftKey && !event.isComposing && !isTouchDevice;

/** A coarse primary pointer means a phone or tablet keyboard. */
export const isTouchDevice = (): boolean =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia("(pointer: coarse)").matches;
